import React, { ReactNode, useContext, useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styles from "./ColumnGraph.module.css";
import { ChartCoordinateData } from "types/Chart";
import { FMSThemeContext } from "contexts/FMSThemeContext";

interface IColumnGraph {
  data: ChartCoordinateData[];
  header: ReactNode;
}
const ColumnGraph: React.FC<IColumnGraph> = React.memo((props) => {
  const { primaryColor } = useContext(FMSThemeContext);

  const minY = useMemo(() => {
    let min = props.data[0].y;
    props.data.forEach((value) => {
      if (value.y < min) {
        min = value.y;
      }
    });
    min = min - min / 10;
    return min < 0 ? 0 : min;
  }, [props.data]);

  return (
    <div className={styles.body}>
      <div className={styles.graphHeader}>{props.header}</div>
      <div className={styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={props.data}>
            <XAxis dataKey="x" tick={{ fontSize: 12 }} />
            <YAxis domain={[minY, "auto"]} tick={{ fontSize: 12 }} />
            <Tooltip />
            <Bar dataKey="y" fill={primaryColor} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
});

export default ColumnGraph;
